import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/es/servicios/software-solutions-services/digitalizacion")({
  head: () => buildRouteHead("/es/servicios/software-solutions-services/digitalizacion"),
  component: SWOffering,
});

